// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  position: relative;
  width: 80px;
}

input[type=checkbox] {
  display: none;
}

.toggle-button-switch {
  position: absolute;
  top: -2px;
  left: 2px;
  width: 36px;
  height: 36px;
  background-color: #fff;
  border-radius: 100%;
  cursor: pointer;
  z-index: 100;
  transition: left 0.3s;
}

.toggle-button-text {
  -webkit-user-select: none;
  /* Safari */
  /* Firefox */
  /* IE10+/Edge */
  user-select: none;
  /* Standard */
  overflow: hidden;
  background-color: #fc3164;
  border-radius: 25px;
  box-shadow: 2px 2px 5px 0 rgba(50, 50, 50, 0.75);
  transition: background-color 0.3s;
}

input[type=checkbox]:disabled ~ .toggle-button-text {
  opacity: 50%;
}

.toggle-button-text-on,
.toggle-button-text-off {
  float: left;
  width: 50%;
  height: 100%;
  line-height: 30px;
  font-family: Lato, sans-serif;
  font-weight: bold;
  color: #fff;
  text-align: center;
}

input[type=checkbox]:checked ~ .toggle-button-switch {
  left: 42px;
}

input[type=checkbox]:checked ~ .toggle-button-text {
  background-color: #2196f3;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/views/toggle-button/toggle-button.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,WAAA;EAEA,YAAA;EAEA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gDAAA;EACA,iCAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;;EAEI,WAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,yBAAA;AACJ","sourcesContent":[":host {\r\n    display: block;\r\n    position: relative;\r\n    width: 80px;\r\n}\r\n\r\ninput[type='checkbox'] {\r\n    display: none;\r\n}\r\n\r\n.toggle-button-switch {\r\n    position: absolute;\r\n    top: -2px;\r\n    left: 2px;\r\n    width: 36px;\r\n    height: 36px;\r\n    background-color: #fff;\r\n    border-radius: 100%;\r\n    cursor: pointer;\r\n    z-index: 100;\r\n    transition: left 0.3s;\r\n}\r\n\r\n.toggle-button-text {\r\n    -webkit-user-select: none;\r\n    /* Safari */\r\n    -moz-user-select: none;\r\n    /* Firefox */\r\n    -ms-user-select: none;\r\n    /* IE10+/Edge */\r\n    user-select: none;\r\n    /* Standard */\r\n    overflow: hidden;\r\n    background-color: #fc3164;\r\n    border-radius: 25px;\r\n    box-shadow: 2px 2px 5px 0 rgba(50, 50, 50, 0.75);\r\n    transition: background-color 0.3s;\r\n}\r\n\r\ninput[type='checkbox']:disabled~.toggle-button-text {\r\n    opacity: 50%;\r\n}\r\n\r\n.toggle-button-text-on,\r\n.toggle-button-text-off {\r\n    float: left;\r\n    width: 50%;\r\n    height: 100%;\r\n    line-height: 30px;\r\n    font-family: Lato, sans-serif;\r\n    font-weight: bold;\r\n    color: #fff;\r\n    text-align: center;\r\n}\r\n\r\ninput[type='checkbox']:checked~.toggle-button-switch {\r\n    left: 42px;\r\n}\r\n\r\ninput[type='checkbox']:checked~.toggle-button-text {\r\n    background-color: #2196f3;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
